import axios from 'axios'

import { url } from '@/api/url'
import { HeadersWithCredentials } from '@/api/header'

export const GetCompetitionByEventIdentifier = async (eventIdentifier, params) => {
    return await axios.get(`${url}/event/competition/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
        params,
    })
}

/** Gates for the organizer header menu (orgaId, _nextEvent, liveJudging.enabled, spectatorsEnabled, judgeAppAllowed). */
export const getEventMenu = async (eventIdentifier) => {
    return await axios.get(`${url}/event/menu/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getPresentationByEventIdentifier = async (leaderboardUrl) => {
    return await axios.get(`${url}/event/presentation/${leaderboardUrl}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getPublicPresentationByEventIdentifier = async (leaderboardUrl) => {
    return await axios.get(`${url}/event/public-presentation/${leaderboardUrl}`, {
        headers: HeadersWithCredentials(),
    })
}

export const RichTextEditorUploadImage = async (competitionId, target, data) => {
    return await axios.put(`${url}/event/rich-text-editor-upload-image/${competitionId}/${target}`, data, {
        headers: HeadersWithCredentials(),
    })
}

// `config` is merged into the axios request — callers pass onUploadProgress when
// they render their own progress indicator (see EventHub's banner).
export const UploadImageAndUpdateCompetition = async (leaderboardId, target, data, config = {}) => {
    return await axios.put(`${url}/event/upload-image-and-update-competition/${leaderboardId}/${target}`, data, {
        headers: HeadersWithCredentials(),
        ...config,
    })
}

export const PartnerAdd = async (leaderboardId, data) => {
    return await axios.post(`${url}/event/partners/add/${leaderboardId}`, data, {
        headers: HeadersWithCredentials(),
    })
}

export const PartnerDelete = async (leaderboardId, partnerId) => {
    return await axios.delete(`${url}/event/partners/delete/${leaderboardId}/${partnerId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const DescriptionUpdate = async (leaderboardId, description) => {
    return await axios.put(
        `${url}/event/description/${leaderboardId}`,
        {
            description,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const DivisionDescriptionUpdate = async (leaderboardId, divisionId, description) => {
    return await axios.put(
        `${url}/event/division/description/${leaderboardId}/${divisionId}`,
        {
            description,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const getWods = async (competitionId) => {
    return axios.get(`${url}/event/wods/${competitionId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const getPublicWods = async (competitionId) => {
    return axios.get(`${url}/event/public-wods/${competitionId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const WorkoutAdd = async (leaderboardId, workout) => {
    return await axios.post(
        `${url}/event/workouts/add/${leaderboardId}`,
        { workout },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const WorkoutUpdate = async (competitionId, workoutId, type, value) => {
    return await axios.put(
        `${url}/event/workouts/update/${competitionId}/${workoutId}`,
        {
            type,
            value,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const WorkoutDelete = async (leaderboardId, workoutId) => {
    return await axios.delete(`${url}/event/workouts/delete/${leaderboardId}/${workoutId}`, {
        headers: HeadersWithCredentials(),
    })
}

export const updateWodConnections = async (competitionId, type, divisionId, competitionWodId, eventPageWodId) => {
    return axios.put(
        `${url}/event/update-wod-connections/${competitionId}`,
        {
            type,
            divisionId,
            competitionWodId,
            eventPageWodId,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const updateWodLeaderboardConnections = async (competitionId, divisionId, competitionWodId, eventPageWodId) => {
    return updateWodConnections(competitionId, 'leaderboard', divisionId, competitionWodId, eventPageWodId)
}

export const updateWodPlanningConnections = async (competitionId, competitionWodId, eventPageWodId) => {
    return updateWodConnections(competitionId, 'planning', undefined, competitionWodId, eventPageWodId)
}

export const IsPublished = async (eventIdentifier) => {
    return await axios.get(`${url}/event/is-published/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const UpdateEventDate = async (leaderboardId, date) => {
    return await axios.put(
        `${url}/event/date/${leaderboardId}`,
        { date },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const UpdateEventLocation = async (leaderboardId, data) => {
    return await axios.put(`${url}/event/location/${leaderboardId}`, data, {
        headers: HeadersWithCredentials(),
    })
}

export const UpdateEventCountry = async (leaderboardId, country) => {
    return await axios.put(
        `${url}/event/country/${leaderboardId}`,
        {
            country,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const UpdateEventCategory = async (leaderboardId, category) => {
    return await axios.put(
        `${url}/event/category/${leaderboardId}`,
        {
            category,
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const updateEventTimezone = async (leaderboardId, timezone) => {
    return await axios.put(
        `${url}/event/timezone/${leaderboardId}`,
        { timezone },
        {
            headers: HeadersWithCredentials(),
        },
    )
}
